import React from "react";

import "../styles/components/Loader.scss";

const ModalLoader = () => {
  return (
    <div className="loader c-els-loader c-els-loader--page">
      <div className="c-els-loader__wrapper">
        <div className="c-els-loader__loading-bar"></div>
        <div className="c-els-loader__loading-bar"></div>
        <div className="c-els-loader__loading-bar"></div>
        <span className="loader__accessible-message u-els-hide-visually">
          Loading page
        </span>
      </div>
    </div>
  );
};

export default ModalLoader;
